module.exports = __webpack_public_path__ + "static/img/Bachelor_010732.50b9b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010732.jpg
// module id = 234
// module chunks = 0